<template>
  <common
    :searchFrom="searchFrom"
    :tableTitle="tableTitle"
    :list="list"
    @crudClick="crudClick"
    :total="total"
    :arrPageSize="arrPageSize"
    :pageSize="searchFrom.pageSize"
    :BoolModal="isshowModal"
    :title="titleModal"
    @changeBindModal="changeBindModal"
    @closedeleteModal="closedeleteModal"
    :unChange="unChange"
    :footerHide="footerHide"
    :width="width"
    :loading="loading"
    :maskClosable="maskClosable"
    :current.sync="current"
    @pageClick="getList"
    ref="common"
  >
    <template slot="add">
      <FormItem>
        <Button type="primary" @click="crudClick(0, 'add')" icon="md-add">
          {{ $t("add") }}
        </Button>
      </FormItem>
    </template>

    <div slot="content">
      <template v-if="crudText == 'delete'">
        <p>{{ $t("titleModal") }}</p>
      </template>
      <template v-else>
        <Form
          label-position="right"
          :model="dataDetails"
          :label-width="140"
          :rules="ruleFrom"
          ref="dataDetails"
        >
          <FormItem :label="$t('warehouseName')" prop="warehouse_id">
            <Select
              v-model="dataDetails.warehouse_id"
              filterable
              :disabled="disabled"
              placeholder="Please Select Warehouse"
            >
              <Option
                v-for="item in objWarehouse"
                :value="item.id"
                :key="item.id"
                >{{ item.warehouse_name }}</Option
              >
            </Select>
          </FormItem>
          <FormItem :label="$t('template_name')" prop="template_name">
            <i-Input
              :disabled="disabled"
              v-model="dataDetails.template_name"
              placeholder="Please Enter Name"
            ></i-Input>
          </FormItem>
          <FormItem :label="$t('template_content')" prop="template_content">
            <i-Input
              :disabled="disabled"
              type="textarea"
              :rows="5"
              v-model="dataDetails.template_content"
              placeholder="Please Enter Content"
            ></i-Input>
          </FormItem>
          <template v-if="crudText != 'show'">
            <Divider />
            <div class="div_label">
              <div class="left_label">
                <span>* </span>
                {{ $t("sms_warning") }}
              </div>
              <div class="desc-class">
                <p
                  v-for="(item, index) in descList"
                  :key="index"
                  v-html="item[$i18n.locale]"
                ></p>
              </div>
            </div>
          </template>
        </Form>
      </template>
    </div>
  </common>
</template>

<script>
import { add, getSms, getDetails, update, del } from "@/api/system/sms";
import common from "_c/common-body";
import basic from "@/utils/basic";
import nodata from "@/utils/nodata";
import boxMes from "@/utils/message";
export default {
  name: "sms",
  components: {
    common,
  },
  data() {
    return {
      current: 1,
      arrPageSize: [15, 30, 50, 100],
      maskClosable: false,
      loading: true,
      width: 600,
      list: [],
      searchFrom: {
        page: 1,
        pageSize: 15,
        keywords: "",
      },
      // Warehouse总数据
      total: 0,
      // 详情模态框显示/隐藏
      isshowModal: false,
      // 数据详情
      dataDetails: {},
      // 删除模态显示/隐藏
      Delmodal1: false,
      // 模态框标题
      isshowModalTitle: "",
      disabled: false,
      ruleFrom: {
        template_name: [
          {
            required: true,
            message: "Name cannot be empty",
            trigger: "blur",
          },
        ],
        template_content: [
          {
            required: true,
            message: "Content cannot be empty",
            trigger: "blur",
          },
        ],
        warehouse_id: [
          {
            required: true,
            type: "number",
            message: "warehouse cannot be empty",
            trigger: "change",
          },
        ],
      },
      footerHide: false,
      crudText: "",
      titleModal: "",
      objWarehouse: {},
      deleteModal: false,
      delId: 0,
      preForm: {},
      unChange: true,
      descList: [
        {
          "zh-CN": "如需模板内容通用时",
          "en-US": "When the template content is required",
        },
        {
          "zh-CN": "帐号用{{$accountId}}替换",
          "en-US": "Account => {{ $accountId }} Replace",
        },
        {
          "zh-CN": "单号用{{$sequence}}替换",
          "en-US": "Order number => {{ $sequence }} Replace",
        },
      ],
    };
  },
  computed: {
    tableTitle() {
      let columns = [];
      columns.push({
        title: this.$t("warehouseName"),
        key: "warehouse_name",
        align: "center",
        tooltip: true,
        minWidth: 100,
      });
      columns.push({
        title: this.$t("template_name"),
        key: "template_name",
        align: "center",
        tooltip: true,
        minWidth: 100,
      });
      columns.push({
        title: this.$t("template_content"),
        key: "template_content",
        align: "center",
        minWidth: 500,
        tooltip: true,
      });
      columns.push({
        title: this.$t("operation"),
        slot: "operation",
        align: "center",
        minWidth: 250,
      });
      return columns;
    },
  },
  watch: {
    dataDetails: {
      handler: function (nowVal) {
        var $this = this;
        for (let i in $this.dataDetails) {
          if (nowVal[i] !== $this.preForm[i]) {
            $this.unChange = false;
            break;
          } else {
            $this.unChange = true;
          }
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getList(this.searchFrom);
  },
  methods: {
    changeBindModal(val) {
      if (!val) {
        this.isshowModal = false;
      } else {
        if (this.crudText === "delete") {
          console.log(this.delId);
          this.deleteList(this.delId);
        } else {
          this.confirm("dataDetails");
        }
      }
    },
    closedeleteModal(e) {
      if (e === false) {
        this.isshowModal = false;
        if (this.crudText != "delete") {
          this.$refs["dataDetails"].resetFields();
        }
      }
    },
    confirm(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.crudText === "add") {
            this.addList();
          } else {
            this.updateList();
          }
        } else {
          console.log(this.$t("fail"));
        }
      });
    },
    crudClick(item, text) {
      this.objWarehouse = basic.objWarehouse();
      this.titleModal = this.$t(text);
      this.maskClosable = false;
      this.width = 600;
      this.footerHide = false;
      this.unChange = true;
      this.disabled = false;
      this.dataDetails = {};
      this.preForm = {};
      if (item !== 0) {
        if (text == "delete") {
          this.width = 300;
          this.delId = item.id;
          this.unChange = false;
          this.maskClosable = true;
        } else {
          if (text === "show") {
            this.disabled = true;
            this.footerHide = true;
            this.maskClosable = true;
          }
          this.dataDetails = {};
          this.preForm = {};
          this.getDetailsList(item.id, text);
        }
      }
      this.isshowModal = true;
      this.crudText = text;
    },
    getDetailsList(id) {
      getDetails(id)
        .then((res) => {
          delete res.data.payload.country;
          this.dataDetails = res.data.payload;
          this.preForm = JSON.parse(JSON.stringify(res.data.payload));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getList(data) {
      this.loading = true;
      getSms(data)
        .then((res) => {if (!res.data.status) {
            this.loading = false;
            boxMes.alertMes(res, this);
            return;
          }
          this.total = res.data.payload.total;
          this.list = res.data.payload.rows.map((item) => {
            let warehouse = nodata.noData(
              basic.objWarehouse(),
              item.warehouse_id,
              "warehouse"
            );
            item.warehouse_name = warehouse.name;
            return item;
          });
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addList() {
      add(this.dataDetails).then((res) => {
        boxMes.alertMes(res, this);
      });
    },
    updateList() {
      update(this.dataDetails).then((res) => {
        boxMes.alertMes(res, this);
      });
    },
    deleteList(id) {
      del(id).then((res) => {
        boxMes.alertMes(res, this);
      });
    },
  },
};
</script>

<style scoped lang="less">
.delBtn {
  margin: 0 10px;
}
.ivu-page {
  margin-top: 20px;
}
.footer-modal {
  width: 100%;
  text-align: center;
}
.div_label {
  display: flex;
}
.div_label span {
  color: red;
}
.left_label {
  width: 140px;
  text-align: right;
  padding: 10px 10px;
}
.desc-class {
  border: 1px solid #dcdee2;
  padding: 10px;
  width: ~"calc(100% - 140px)";
  border-radius: 4px;
}
.ivu-divider-horizontal {
  margin: 10px 0;
}
</style>
